<template>
  <div v-if="transaction" class="transaction-form">
    <div class="display-2 font-weight-bold my-6 text-capitalize">
      {{ transaction.renter_code }}
    </div>

    <v-row>
      <v-col cols="12" sm="8">
        <v-form ref="form" style="max-width: 600px">
          <v-row>
            <v-col cols="12" sm="8">
              <label class="text-field-label">Request Date</label>
              <v-text-field
                v-model="transaction.addedDate"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
              <label class="text-field-label">Status</label>
              <v-text-field
                v-model="transaction.status"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">From</label>
              <v-text-field
                v-model="transaction.fromDate"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="text-field-label">To</label>
              <v-text-field
                v-model="transaction.toDate"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <label class="text-field-label">Renter</label>
              <v-text-field
                v-model="transaction.renterName"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <div
            class="headline font-weight-light mt-4 font-serif text-capitalize"
          >
            Tool Information
          </div>

          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Name</label>
              <v-text-field
                v-model="transaction.toolName"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Owner</label>
              <v-text-field
                v-model="transaction.ownerName"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="12">
              <label class="text-field-label">Address</label>
              <v-text-field
                v-model="tool.address_1"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" sm="6">
              <label class="text-field-label">City or Suburb</label>
              <v-text-field
                v-model="tool.city"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <label class="text-field-label">Postcode</label>
              <v-text-field
                v-model="tool.postal_code"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" sm="6">
              <label class="text-field-label">Country</label>
              <v-text-field
                v-model="tool.country"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6">
              <label class="text-field-label">State</label>
              <v-text-field
                v-model="tool.state"
                flat
                solo
                required
                hide-details="auto"
                class="mt-2"
                readonly
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
      <v-col cols="12" sm="4">
        <v-card>
          <v-card-title class="subheading font-weight-bold">
            Price Breakdown
          </v-card-title>

          <v-divider></v-divider>

          <v-list dense>
            <v-list-item>
              <v-list-item-content
                >${{ pricing.price | price }} x
                {{ pricing.number_of_days }} days(s)</v-list-item-content
              >
              <v-list-item-content class="justify-end">
                ${{ pricing.total.sub_total | price }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content
                >GST ({{ pricing.tax }}%)</v-list-item-content
              >
              <v-list-item-content class="justify-end">
                ${{ pricing.total.tax | price }}
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-content>Service Fee</v-list-item-content>
              <v-list-item-content class="justify-end">
                (${{ pricing.total.service_fee | price }})
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="mt-2">
              <v-list-item-content class="font-weight-bold"
                >Total</v-list-item-content
              >
              <v-list-item-content class="font-weight-bold justify-end">
                ${{ pricing.total.grand_total | price }}
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import Transaction from '@/models/Transaction'

export default {
  props: {
    transaction: {
      type: [Transaction, Object]
    }
  },

  computed: {
    pricing() {
      return this.transaction && this.transaction.details
        ? this.transaction.details
        : { total: {} }
    },

    tool() {
      return this.transaction && this.transaction.tool
        ? this.transaction.tool
        : {}
    }
  }
}
</script>
